export default {"src":"/_next/static/media/4-icon.7b789561.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};